import React from 'react';
import { Button } from './ui/button';
import { Check } from 'lucide-react';
import { useLanguage } from '../lib/LanguageContext';
export function MobileAppSection() {
  const {
    t
  } = useLanguage();
  return <section className="py-16 md:py-24 lg:py-40 bg-forest-50 overflow-hidden" data-id="element-219">
      <div className="container mx-auto px-4 sm:px-6 md:px-8" data-id="element-220">
        <div className="grid md:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-221">
          {/* Left Content */}
          <div data-id="element-222">
            <p className="text-forest-500 font-semibold text-xs uppercase tracking-[0.2em] mb-6" data-id="element-223">
              {t.mobile.label}
            </p>
            <h2 className="text-4xl md:text-5xl font-bold text-forest-900 mb-6 tracking-tight leading-tight" data-id="element-224">
              {t.mobile.headline}
            </h2>
            <p className="text-forest-600 text-xl font-light mb-10 leading-relaxed" data-id="element-225">
              {t.mobile.subtitle}
            </p>

            <ul className="space-y-3 mb-10" data-id="element-226">
              {t.mobile.features.map((item, idx) => <li key={idx} className="flex items-center text-forest-700 text-base" data-id="element-227">
                  <div className="w-5 h-5 bg-forest-100 rounded-full flex items-center justify-center mr-3 flex-shrink-0" data-id="element-228">
                    <Check className="w-3 h-3 text-brand-green" data-id="element-229" />
                  </div>
                  {item}
                </li>)}
            </ul>

            <Button onClick={() => window.open('https://wa.me/628127634091?text=Halo%2C+saya+ingin+mendapatkan+brosur+produk+sawit-net', '_blank')} className="bg-brand-green hover:bg-forest-600 text-white font-semibold h-12 px-8 rounded-lg shadow-sm hover:shadow-md transition-all" data-id="element-230">
              {t.mobile.cta}
            </Button>
          </div>

          {/* Right Content - iPhone 17 Pro Max Mockup */}
          <div className="flex justify-center lg:justify-end" data-id="element-231">
            <div className="relative w-[260px] sm:w-[300px]" data-id="element-232">
              {/* Outer titanium frame */}
              <div className="relative rounded-[3.5rem] p-[3px] shadow-2xl" style={{
              background: 'linear-gradient(145deg, #8E8E93 0%, #636366 30%, #48484A 60%, #636366 80%, #8E8E93 100%)',
              boxShadow: '0 30px 80px rgba(0,0,0,0.45), 0 0 0 1px rgba(255,255,255,0.08), inset 0 1px 0 rgba(255,255,255,0.15)'
            }} data-id="element-233">
                {/* Inner glass/screen housing */}
                <div className="rounded-[3.3rem] overflow-hidden" style={{
                background: '#1C1C1E'
              }} data-id="element-234">
                  {/* Screen bezel top */}
                  <div className="relative bg-black" style={{
                  paddingTop: '10px',
                  paddingBottom: '4px'
                }} data-id="element-235">
                    {/* Dynamic Island */}
                    <div className="flex justify-center" data-id="element-236">
                      <div className="bg-black rounded-full" style={{
                      width: '110px',
                      height: '34px',
                      boxShadow: 'inset 0 0 0 1px rgba(255,255,255,0.06)'
                    }} data-id="element-237" />
                    </div>
                  </div>

                  {/* Screen Content */}
                  <div className="bg-white relative overflow-hidden" style={{
                  minHeight: '480px'
                }} data-id="element-238">
                    <img src="https://cdn.magicpatterns.com/uploads/fvNEMon52yMJdYTqig7Tpm/Screen_Shot_2026-02-21_at_05.19.32.png" alt="sawit-net mobile app" className="w-full h-full object-cover object-top" data-id="element-239" />
                  </div>

                  {/* Screen bezel bottom — home indicator area */}
                  <div className="bg-black flex justify-center items-center py-3" data-id="element-240">
                    <div className="w-28 h-1 bg-white/30 rounded-full" data-id="element-241" />
                  </div>
                </div>

                {/* Side buttons — Action button (left top) */}
                <div className="absolute rounded-full" style={{
                left: '-5px',
                top: '90px',
                width: '4px',
                height: '32px',
                background: 'linear-gradient(180deg, #8E8E93, #636366)',
                boxShadow: '-1px 0 3px rgba(0,0,0,0.4)'
              }} data-id="element-242" />
                {/* Volume up */}
                <div className="absolute rounded-full" style={{
                left: '-5px',
                top: '140px',
                width: '4px',
                height: '52px',
                background: 'linear-gradient(180deg, #8E8E93, #636366)',
                boxShadow: '-1px 0 3px rgba(0,0,0,0.4)'
              }} data-id="element-243" />
                {/* Volume down */}
                <div className="absolute rounded-full" style={{
                left: '-5px',
                top: '204px',
                width: '4px',
                height: '52px',
                background: 'linear-gradient(180deg, #8E8E93, #636366)',
                boxShadow: '-1px 0 3px rgba(0,0,0,0.4)'
              }} data-id="element-244" />
                {/* Power button (right) */}
                <div className="absolute rounded-full" style={{
                right: '-5px',
                top: '160px',
                width: '4px',
                height: '72px',
                background: 'linear-gradient(180deg, #8E8E93, #636366)',
                boxShadow: '1px 0 3px rgba(0,0,0,0.4)'
              }} data-id="element-245" />
              </div>

              {/* Glow reflection */}
              <div className="absolute -bottom-8 left-1/2 -translate-x-1/2 w-48 h-12 bg-brand-green/20 blur-2xl rounded-full pointer-events-none" data-id="element-246" />
              {/* Screen reflection */}
              <div className="absolute top-[14px] left-[14px] right-[14px] h-[40%] rounded-t-[3rem] pointer-events-none" style={{
              background: 'linear-gradient(160deg, rgba(255,255,255,0.06) 0%, transparent 60%)'
            }} data-id="element-247" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}